//TODO: replace ramda with non deprecated library
import { compose, equals, fromPairs, map, toPairs } from 'ramda';

import { RecommendationSettingsType } from '../RecommendationSettings.types.js';

type TransformMapType = [
  string,
  string | null | boolean | number | { min: string | null; max: string | null },
];

const transformBudgetReallocationLimits = ([
  key,
  value,
]: TransformMapType): TransformMapType =>
  key === 'budgetReallocationLimits'
    ? [
        key,
        value &&
        typeof value === 'object' &&
        ((value.min === null && value.max === null) ||
          value.min === '' ||
          value.max === '')
          ? null
          : value,
      ]
    : [key, value];

const unnecessaryKeys = ['isBudgetLimited'];

const removeUnnecessaryKeys = ([
  key,
  value,
]: TransformMapType): TransformMapType =>
  unnecessaryKeys.includes(key) ? ([] as any) : [key, value];

const isEquals = (
  prevSettings: Partial<RecommendationSettingsType>,
  nextSettings: Partial<RecommendationSettingsType>,
): boolean => {
  const prev = compose(
    fromPairs,
    map(compose(removeUnnecessaryKeys, transformBudgetReallocationLimits)),
    toPairs,
  )(prevSettings);
  const next = compose(
    fromPairs,
    map(compose(removeUnnecessaryKeys, transformBudgetReallocationLimits)),
    toPairs,
  )(nextSettings);

  return equals(prev, next);
};

export default isEquals;
